// Saisie et affichage des montants en euros (section « Recettes & achats », 27/10/2026).
// Module PUR, sans DOM : testable sous Vitest.

/**
 * Lit un montant saisi au clavier (« 45,90 », « 45.9 », « 1 250 »).
 *   - champ vide           -> null      (montant non renseigné : c'est permis)
 *   - nombre ≥ 0 valide    -> le nombre, arrondi au centime
 *   - saisie illisible / négative -> undefined (l'écran affiche une erreur)
 */
export function lireMontant(saisie: string): number | null | undefined {
  const texte = saisie.replace(/\s/g, '').replace(',', '.')
  if (texte === '') return null
  if (!/^\d+(\.\d+)?$/.test(texte)) return undefined
  const n = Number(texte)
  if (!Number.isFinite(n) || n < 0) return undefined
  return Math.round((n + Number.EPSILON) * 100) / 100
}

/** Montant affiché à la française : « 1 250,90 € ». */
export const euro = (n: number): string =>
  n.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })
